/**
 * Created by superman on 17/2/16.
 * http配置
 */
// 存放公共方法，其他的放在page 各自的页面模块，同页面命名
import axios from 'axios'
// import jsonp from 'jsonp'
import qs from 'qs'
import jsonp from 'jsonp'
import Config from '../config/config.js'
import Cookie from 'js-cookie'
// import store from './store/store'
// import * as types from './store/types'
// import router from './router'
function isIE(){
    if (!!window.ActiveXObject || "ActiveXObject" in window)
    return true;
    else
    return false;
}
// axios 配置
axios.defaults.timeout = 300000;
axios.defaults.withCredentials = true;
// axios.defaults.baseURL = '/backend/';
   
// http request 拦截器
axios.interceptors.request.use(
    config => {
        
        // if (store.state.token) {
        //     config.headers.Authorization = `token ${store.state.token}`;
        // }
        // 读取内购section 信息
        if(!isIE()&&agho&&agho.hasOwnProperty('sessionInfo')&&typeof agho.sessionInfo ==='function'){
          let sessionInfos=agho.sessionInfo();
            config.headers['X-AGH-guid']=sessionInfos.guid;
            config.headers['X-AGH-gcorpId']=sessionInfos.gcorpId;
            config.headers[Config.token_header_name]=getCookie(Config.token_cookie_name)
        }
        // 双斜杠替换成单斜杠
        if(-1 == config.url.indexOf('upload.qbox.me')){
            config.url = config.url.replace(/\/\//g,'/').replace(/http\:\//g,'http://').replace(/https\:\//g,'https://');
        }
        return config;
    },
    err => {
        // return Promise.reject(err);
    });

// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.errno == 302) {
            let currentLink = encodeURIComponent(window.location.href);
            let hasParams=response.data.body.location.indexOf('?')!==-1;
            let caslogin = hasParams?response.data.body.location + '&redirect=' + currentLink:response.data.body.location + '?redirect=' + currentLink;
            window.location = caslogin
            return
        }
        if(response.data.errno == 401){
            let currentLink = encodeURIComponent(window.location.href);
            window.location = Config.agh_cas_domin + '/backend/cas/api/checkLoginForward?redirect=' + currentLink + '&loginCallback=' + Config.ddguanhuai_domin + '/apirouter/acas/api/setLogin';
            // let caslogin,count;
            // if(Cookie.get('loginCount')){
            //     count=Cookie.get('loginCount')
            // }else{
            //     count=0;
            // }
            // count++;
            // Cookie.set('loginCount',count,{expires:0.0014});
            // if(count>2){
            //     caslogin = Config.agh_cas_domin + '/backend/cas/api/checkLoginForward?redirect=' + currentLink;
            // }else{
            //     caslogin = Config.cas_domin + '?redirect=' + currentLink;
            // } 
            // window.location = caslogin
            return
        }
        if(response.data.errno == 403){
            window.location = '/AiGuanHuai/agh/pop/error'
        }
        if (response.data.errno == 410) {
            alert(response.data.error)
            return
        }
        
        let gcas_token = getCookie(Config.access_token_cookie_name);
        let acas_token = getCookie(Config.token_cookie_name);
        if(acas_token != 'aiguanhuai_'+gcas_token) {
            let currentLink = encodeURIComponent(window.location.href);
            window.location = Config.agh_cas_domin + '/backend/cas/api/checkLoginForward?redirect=' + currentLink + '&loginCallback=' + Config.ddguanhuai_domin + '/apirouter/acas/api/setLogin';
        }

        return response;
    },
    error => {
        
    });
const httpGet = (url, params) => {
    let t=new Date().getTime();
    if(params){
        Object.assign(params,{t:t})//解决ie get请求缓存问题
    }

// {headers:{"X-Custom-Header":"1111"}}
    return axios.get(url, { params: params })
}
const httpPost = (url, formData, qsParams) => {
    let t=new Date().getTime();
    var url = url+'?t='+t;
    if (qsParams) {
        url += '&' + qs.stringify(qsParams)
    }
    return axios.post(url, qs.stringify(formData))
}

const httpPut = (url,formData)=> {
    let t = new Date().getTime();
    var url = url+'?t='+t;
    return axios.put(url,qs.stringify(formData))
}
const httpDelete = (url, params) => {
    let t=new Date().getTime();
    var url = url+params+'?t='+t;

    return axios.delete(url)
}

const httpPostPayload = (url, formData, qsParams) => {
    let t=new Date().getTime();
    var url = url+'?t='+t;
    if (qsParams) {
        url += '&' + qs.stringify(qsParams)
    }
    return axios.post(url, formData)
}
const httpPostFormData = (url, formData, qsParams) => {
    let t=new Date().getTime();
    var url = url+'?t='+t;
    if (qsParams) {
        url += '&' + qs.stringify(qsParams)
    }
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return axios.post(url, formData, config)
}
const httpJsonp = (url, params, cb) => {
        var url = url;
        if (params) {
            url += '?' + qs.stringify(params)
        }
        return jsonp(url, null, cb)
    }
    // const httpJsonp=(url,params,cb)=>{
var getCookie = name => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

export { httpGet, httpPost, httpPostPayload, httpJsonp ,httpDelete,httpPut, httpPostFormData}
